<template>
  <div>
    <v-navigation-drawer
      :value="isAddEditGlassSidebar"
      temporary
      touchless
      :stateless="dialog || alertGuard"
      floating
      right
      app
      :width="$vuetify.breakpoint.xsOnly ? '100%' : 450"
      :class="$vuetify.breakpoint.xsOnly ? 'rounded-0' : 'rounded-l-xl'"
      @input="onDrawerInput"
    >
      <v-card flat tile>
        <v-card-title class="px-4 thead-color">
          <v-avatar size="50" color="primary" class="mr-3">
            <v-icon color="white" :size="30">
              {{ icons.mdiSunglasses }}
            </v-icon>
          </v-avatar>
          <span class="font-weight-semibold text-base primary--text">Cam Ekle</span>

          <v-spacer></v-spacer>
          <v-btn icon small @click="closeSidebar">
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>
        <ValidationObserver ref="form" tag="div">
          <form @submit.prevent>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <v-autocomplete
                v-model="formField.brand"
                :items="items.brand"
                label="Marka"
                item-text="branddesc"
                item-value="branddesc"
                :readonly="!formField.reverse"
                class="rounded-0"
                hide-details
                attach
                eager
                filled
                :error-messages="errors"
                :menu-props="{ bottom: true, offsetY: true }"
                @focus="brandFocus()"
                @change="brandChange()"
              >
                <template #no-data>
                  <v-alert v-if="loadingSelectStatus === 'error'" type="error" text class="ma-0 rounded-0">
                    {{ loadingSelectText }}
                  </v-alert>
                  <div v-else class="pa-4 text-body-2">
                    Veri bulunamadı
                  </div>
                </template>
                <template #progress>
                  <v-alert
                    :type="loadingSelectStatus"
                    :color="!loadingSelectStatus ? 'primary' : null"
                    text
                    class="ma-0 rounded-0"
                  >
                    <template v-if="loadingSelectStatus === null" #prepend>
                      <v-progress-circular
                        class="mr-3"
                        :width="2"
                        :size="25"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </template>
                    {{ loadingSelectText }}
                  </v-alert>
                </template>
              </v-autocomplete>
            </ValidationProvider>

            <ValidationProvider v-slot="{ errors }" rules="required">
              <v-autocomplete
                v-model="formField.name"
                :items="items.name"
                :disabled="items.brand.length === 0"
                :readonly="!formField.reverse"
                label="Ürün Adı"
                item-text="stext"
                item-value="stext"
                return-object
                class="rounded-0"
                hide-details
                attach
                eager
                filled
                :error-messages="errors"
                :menu-props="{ bottom: true, offsetY: true }"
                @focus="nameFocus()"
                @change="nameChange()"
              >
                <template #no-data>
                  <v-alert v-if="loadingSelectStatus === 'error'" type="error" text class="ma-0 rounded-0">
                    {{ loadingSelectText }}
                  </v-alert>
                  <div v-else class="pa-4 text-body-2">
                    Veri bulunamadı
                  </div>
                </template>
                <template #progress>
                  <v-alert
                    :type="loadingSelectStatus"
                    :color="!loadingSelectStatus ? 'primary' : null"
                    text
                    class="ma-0 rounded-0"
                  >
                    <template v-if="loadingSelectStatus === null" #prepend>
                      <v-progress-circular
                        class="mr-3"
                        :width="2"
                        :size="25"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </template>
                    {{ loadingSelectText }}
                  </v-alert>
                </template>
              </v-autocomplete>
            </ValidationProvider>

            <ValidationProvider v-slot="{ errors }" rules="required">
              <v-autocomplete
                v-model="formField.sph"
                :items="items.sph"
                :disabled="items.name.length === 0"
                label="SPH"
                class="rounded-0"
                hide-details
                attach
                eager
                filled
                :error-messages="errors"
                :menu-props="{ bottom: true, offsetY: true }"
              >
                <template #no-data>
                  <v-alert v-if="loadingSelectStatus === 'error'" type="error" text class="ma-0 rounded-0">
                    {{ loadingSelectText }}
                  </v-alert>
                  <div v-else class="pa-4 text-body-2">
                    Veri bulunamadı
                  </div>
                </template>
                <template #progress>
                  <v-alert
                    :type="loadingSelectStatus"
                    :color="!loadingSelectStatus ? 'primary' : null"
                    text
                    class="ma-0 rounded-0"
                  >
                    <template v-if="loadingSelectStatus === null" #prepend>
                      <v-progress-circular
                        class="mr-3"
                        :width="2"
                        :size="25"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </template>
                    {{ loadingSelectText }}
                  </v-alert>
                </template>
              </v-autocomplete>
            </ValidationProvider>

            <ValidationProvider v-slot="{ errors }" rules="required">
              <v-select
                v-model="formField.cyl"
                :items="items.cyl"
                :disabled="items.name.length === 0"
                label="CYL"
                class="rounded-0"
                hide-details
                attach
                eager
                filled
                :error-messages="errors"
                :menu-props="{ bottom: true, offsetY: true }"
              >
                <template #no-data>
                  <v-alert v-if="loadingSelectStatus === 'error'" type="error" text class="ma-0 rounded-0">
                    {{ loadingSelectText }}
                  </v-alert>
                  <div v-else class="pa-4 text-body-2">
                    Veri bulunamadı
                  </div>
                </template>
                <template #progress>
                  <v-alert
                    :type="loadingSelectStatus"
                    :color="!loadingSelectStatus ? 'primary' : null"
                    text
                    class="ma-0 rounded-0"
                  >
                    <template v-if="loadingSelectStatus === null" #prepend>
                      <v-progress-circular
                        class="mr-3"
                        :width="2"
                        :size="25"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </template>
                    {{ loadingSelectText }}
                  </v-alert>
                </template>
              </v-select>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <v-select
                v-model="formField.direction"
                :items="items.direction"
                label="Cam Yönü"
                :readonly="!formField.reverse"
                class="rounded-0"
                hide-details
                return-object
                attach
                eager
                filled
                :error-messages="errors"
                :menu-props="{ bottom: true, offsetY: true }"
              ></v-select>
            </ValidationProvider>

            <v-select
              v-if="formField.haswarrantycard != '2'"
              v-model="formField.axe"
              :items="items.axe"
              label="Axe"
              class="rounded-0"
              hide-details
              attach
              eager
              filled
              :menu-props="{ bottom: true, offsetY: true }"
            ></v-select>

            <ValidationProvider v-if="formField.haswarrantycard != '2'" v-slot="{ errors }" rules="required">
              <v-text-field
                v-model="formField.fullname"
                :readonly="!formField.reverse"
                label="Kullanıcı Adı"
                class="rounded-0"
                hide-details
                filled
                :error-messages="errors"
              />
            </ValidationProvider>

            <ValidationProvider v-slot="{ errors }" rules="required|min_value:1">
              <v-text-field
                v-model.number="formField.qty"
                min="1"
                type="number"
                label="Miktar"
                class="rounded-0"
                hide-details
                filled
                :error-messages="errors"
              />
            </ValidationProvider>
          </form>
        </ValidationObserver>

        <v-divider />

        <div v-if="TESF > 0">
          <v-alert
            rounded="0"
            type="info"
            text
            color="primary"
            class="text-caption ma-0 d-flex align-center"
          >
            Birim Satış Fiyatı :
            <v-progress-circular
              v-if="priceLoading"
              indeterminate
              color="primary"
              :size="16"
              :width="2"
              class="ml-2"
            />
            <span
              v-else
              class="ml-1 font-weight-bold"
            >{{ formField.price | currency }}</span>
          </v-alert>
          <v-divider />
          <v-alert
            rounded="0"
            type="info"
            text
            color="primary"
            class="text-caption ma-0 d-flex align-center"
          >
            Tavsiye Edilen Perakende Satış Fiyatı :
            <v-progress-circular
              v-if="priceLoading"
              indeterminate
              color="primary"
              :size="16"
              :width="2"
              class="ml-2"
            />
            <span
              v-else
              class="ml-1 font-weight-bold"
            >{{ formField.price_ps | currency }}</span>
          </v-alert>
        </div>
        <div v-if="STOCK_CONTROL">
          <v-alert rounded="0" :type="stockType" text class="text-caption ma-0">
            {{ stockText }}
          </v-alert>
        </div>
      </v-card>
      <v-container v-if="$vuetify.breakpoint.xsOnly" class="pb-16">
        <v-row align="center" no-gutters class="pb-16">
          <v-col cols="4">
            <v-btn plain small block @click="closeSidebar"> Vazgeç </v-btn>
          </v-col>
          <v-col cols="8">
            <v-btn
              color="primary"
              rounded
              x-large
              block
              class="me-3"
              :disabled="stockDisabled || isSubmitting || isAddPending || priceLoading"
              :loading="isSubmitting || isAddPending || priceLoading"
              @click="submitForm"
            >
              Ekle
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <template v-if="!$vuetify.breakpoint.xsOnly" v-slot:append>
        <v-container>
          <v-row align="center" no-gutters>
            <v-col cols="4">
              <v-btn plain small block @click="closeSidebar"> Vazgeç </v-btn>
            </v-col>
            <v-col cols="8">
              <v-btn
                color="primary"
                rounded
                x-large
                block
                class="me-3"
                :disabled="stockDisabled || isSubmitting || isAddPending || priceLoading"
                :loading="isSubmitting || isAddPending || priceLoading"
                @click="submitForm"
              >
                Ekle
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-navigation-drawer>
    <v-dialog v-model="dialog" max-width="360" persistent>
      <v-card>
        <v-card-title> {{ confrimText }} </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closeSidebar"> Hayır </v-btn>
          <v-btn color="primary" depressed @click="dialogConfrim"> Evet </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { newItemId, useOrderStore } from '@/stores/order'
import useAlertGuard from '@/utils/useAlertGuard'
import { showAppSnackbar } from '@/utils/showSnackbar'
import axios from '@axios'
import { mdiClose, mdiSunglasses } from '@mdi/js'
import { computed, nextTick, onMounted, ref, watch } from '@vue/composition-api'

export default {
  model: {
    prop: 'isAddEditGlassSidebar',
    event: 'update:is-add-edit-glass-sidebar',
  },
  props: {
    isAddEditGlassSidebar: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { alertGuard } = useAlertGuard()

    const isSubmitting = ref(false) // Butonun tıklanmasını engellemek için yeni bir değişken
    const isAddPending = ref(false)
    const addPendingCount = ref(0)
    const dialog = ref(false)

    const startAddPending = () => {
      addPendingCount.value += 1
      isAddPending.value = true
    }

    const endAddPending = () => {
      addPendingCount.value = Math.max(0, addPendingCount.value - 1)
      if (addPendingCount.value === 0) {
        isAddPending.value = false
      }
    }

    const trackAddPending = promise => {
      startAddPending()
      return promise.finally(endAddPending)
    }

    // const userData = JSON.parse(localStorage.getItem('userData'))

    const order = useOrderStore()
    const form = ref(null)

    const formField = ref({
      id: null,
      type: 'stock',
      brand: null,
      name: null,
      itemcode: null,
      direction: { text: 'Sağ', value: 'SAĞ', reverse: { text: 'Sol', value: 'SOL' } },
      sph: null,
      cyl: { text: 'a', value: 'a' },
      qty: 1,
      haswarrantycard: '2',
      fullname: null,
      axe: null,
      title: null,
      price: 0,
      price_ps: 0,
      tax: 0,
      discount: [],
      currency: null,
      tax_rate: null,
      prd_code: null,
      reverse: true,
      cmpDiscValueType: null,
      cmpDiscValue: null,
      cmpDiscMsg: null,
      subTotal: 0,
    })
    const formFieldCopy = ref({})
    onMounted(() => {
      formFieldCopy.value = { ...formField.value }
    })

    const items = ref({
      brand: [],
      name: [],
      direction: [
        {
          text: 'Sağ',
          value: 'SAĞ',
          reverse: {
            text: 'Sol',
            value: 'SOL',
          },
        },
        {
          text: 'Sol',
          value: 'SOL',
          reverse: {
            text: 'Sağ',
            value: 'SAĞ',
          },
        },
      ],
      sph: [],
      cyl: [],
      axe: Array.from({ length: 180 }, (_, x) => x),
    })
    const itemsCopy = ref({})
    onMounted(() => {
      itemsCopy.value = { ...items.value }
    })

    const loadingSelectStatus = ref(null)
    const loadingSelectText = ref('Lütfen Bekleyin Yükleniyor')

    const brandFocus = () => {
      const params = new URLSearchParams()
      params.append('method', 'getStockBrandByPrd')
      trackAddPending(
        axios
          .post('', params)
          .then(response => {
            if (response.data.error) {
              loadingSelectText.value = response.data.msg
              loadingSelectStatus.value = 'error'

              return
            }
            items.value.brand = response.data.detail
          })
          .catch(e => {
            loadingSelectText.value = 'Bir hata oldu tekrar deneyin'
            loadingSelectStatus.value = 'error'
          }),
      )
    }

    const brandChange = () => {
      formField.value.name = null
      formField.value.itemcode = null
      formField.value.sph = null
      formField.value.cyl = null
      formField.value.haswarrantycard = '2'
      items.value.name = []
      items.value.sph = []
      items.value.cyl = []
      clearPrice()
    }

    const nameFocus = () => {
      const params = new URLSearchParams()
      params.append('method', 'getStockPrdNames')
      params.append('brand', formField.value.brand)
      trackAddPending(
        axios
          .post('', params)
          .then(response => {
            if (response.data.error) {
              loadingSelectText.value = response.data.msg
              loadingSelectStatus.value = 'error'

              return
            }

            items.value.name = response.data.detail
          })
          .catch(e => {
            loadingSelectText.value = 'Bir hata oldu tekrar deneyin'
            loadingSelectStatus.value = 'error'
          }),
      )
    }

    const nameChange = () => {
      formField.value.itemcode = formField.value.name.itemcode
      formField.value.haswarrantycard = formField.value.name.haswarrantycard

      formField.value.sph = null
      formField.value.cyl = null
      items.value.sph = []
      items.value.cyl = []
      clearPrice()
    }

    watch(
      () => ({
        brand: formField.value.brand,
        name: formField.value.name,
      }),
      data => {
        if (data.brand && data.name?.itemcode) {
          const params = new URLSearchParams()
          params.append('method', 'getStockRangeByFilter')
          params.append('itemcode', formField.value.name.itemcode)
          params.append('brand', formField.value.brand)
          trackAddPending(
            axios
              .post('', params)
              .then(response => {
                if (response.data.error) {
                  loadingSelectText.value = response.data.msg
                  loadingSelectStatus.value = 'error'

                  return
                }

                let positiveSPH = []
                let negativeSPH = []
                response.data.detail.sphValues.forEach(item => {
                  if (item >= 0) {
                    positiveSPH.push(item)
                  } else {
                    negativeSPH.push(item)
                  }
                })
                positiveSPH = positiveSPH.sort((a, b) => a - b)
                negativeSPH = negativeSPH.sort((a, b) => b - a)
                const valueSPH = positiveSPH.concat(negativeSPH)

                let positiveCYL = []
                let negativeCYL = []
                response.data.detail.cylValues.forEach(item => {
                  if (item >= 0) {
                    positiveCYL.push(item)
                  } else {
                    negativeCYL.push(item)
                  }
                })
                positiveCYL = positiveCYL.sort((a, b) => a - b)
                negativeCYL = negativeCYL.sort((a, b) => b - a)
                const valueCYL = positiveCYL.concat(negativeCYL)

                items.value.cyl = response.data.detail.cylValues
                items.value.sph = response.data.detail.sphValues

                formField.value.cyl = items.value.cyl[0]
              })
              .catch(e => {
                loadingSelectText.value = 'Bir hata oldu tekrar deneyin'
                loadingSelectStatus.value = 'error'
              }),
          )
        }
      },
    )

    const toDiopterNumber = value => {
      if (typeof value === 'string') {
        return Number(value.replace(/^\+/, ''))
      }

      return Number(value)
    }

    const buildGlassPrdCode = (itemcode, sph, cyl) => {
      if (itemcode === null || sph === null || cyl === null) {
        return null
      }

      const baseCode = String(itemcode).replace(/\++$/, '')

      const sphNum = toDiopterNumber(sph)
      const cylNum = toDiopterNumber(cyl)

      let sphStr
      let cylStr
      if (sphNum == 0) {
        sphStr = '-0000'
      } else if (sphNum > 0) {
        sphStr = `+${String(sphNum).padStart(4, '0')}`
      } else {
        sphStr = `-${String(sphNum * -1).padStart(4, '0')}`
      }

      if (cylNum == 0) {
        cylStr = '-000'
      } else if (cylNum > 0) {
        cylStr = `+${String(cylNum).padStart(3, '0')}`
      } else {
        cylStr = `-${String(cylNum * -1).padStart(3, '0')}`
      }

      return `${baseCode}${sphStr}${cylStr}`
    }

    const prdcode = computed(() =>
      buildGlassPrdCode(formField.value.itemcode, formField.value.sph, formField.value.cyl),
    )

    const TESF = computed(() => {
      if (formField.value.itemcode !== null && formField.value.sph !== null && formField.value.cyl !== null) {
        return 1
      }

      return 0
    })

    const priceLoading = ref(false)

    const clearPrice = () => {
      formField.value.price = 0
      formField.value.price_ps = 0
      formField.value.currency = null
      formField.value.prd_code = null
      formField.value.title = null
      formField.value.tax_rate = null
      priceLoading.value = false
    }

    const lastPriceKey = ref(null)
    const priceRequestId = ref(0)
    watch(
      [() => formField.value.itemcode, () => formField.value.sph, () => formField.value.cyl, () => prdcode.value],
      ([itemcode, sph, cyl, prdCodeValue]) => {
        if (itemcode === null || sph === null || cyl === null) {
          lastPriceKey.value = null
          clearPrice()
          return
        }

        if (!prdCodeValue || lastPriceKey.value === prdCodeValue) {

          return
        }
        lastPriceKey.value = prdCodeValue
        formField.value.price = 0
        formField.value.price_ps = 0
        formField.value.currency = null
        formField.value.prd_code = null
        priceLoading.value = true
        const requestId = ++priceRequestId.value

        // İlk fiyat sorgusu her zaman qty=1 ile gönderilir; kullanıcının o an
        // formda girmiş olabileceği miktar bu sorguyu etkilemez.
        const params = new URLSearchParams()
        params.append('method', 'getProductPrice')
        params.append('prdcode', prdCodeValue)
        params.append('qty', 1)
        fetchProductPrice(params, requestId)
      },
    )

    const fetchProductPrice = (params, requestId) => {
        trackAddPending(
          axios
            .post('', params)
            .then(response => {
              if (requestId !== priceRequestId.value) return

              if (response.data.error) {
                showAppSnackbar(response.data.msg, 'warning')
                cancelPriceSelection()

                return
              }

              formField.value.title = response.data.detail.title2
              formField.value.price = response.data.detail.price
              formField.value.price_ps = response.data.detail.price_ps
              formField.value.currency = response.data.detail.price_currency
              formField.value.tax_rate = response.data.detail.tax_rate
              formField.value.taxAmount = response.data.detail.taxAmount
              formField.value.netAmount = response.data.detail.netAmount
              formField.value.subTotal = response.data.detail.subTotal
              formField.value.prd_code = buildGlassPrdCode(
                formField.value.itemcode,
                formField.value.sph,
                formField.value.cyl,
              )
              formField.value.discount = []
              if (response.data.detail.discAmount) {
                formField.value.discount.push(response.data.detail.discAmount)
              }
            })
            .catch(() => {
              showAppSnackbar('Bir hata oldu tekrar deneyin', 'error')
              cancelPriceSelection()
            })
            .finally(() => {
              priceLoading.value = false
            }),
        )
    }


    const stockText = ref('')
    const stockType = ref(null)
    const stockStatus = ref(false)
    const stockDisabled = ref(false)
    const stockDetail = ref({ merkez: 0, depo: 0, toplam: 0 })
    const STOCK_CONTROL = computed(() => {
      if (formField.value.itemcode === null || formField.value.sph === null || formField.value.cyl === null) {
        return false
      }

      return stockStatus.value || stockDisabled.value
    })

    const lastStockKey = ref(null)
    const stockRequestId = ref(0)

    const cancelPriceSelection = () => {
      lastPriceKey.value = null
      lastStockKey.value = null
      formField.value.sph = null
      formField.value.cyl = null
      clearPrice()
      stockStatus.value = false
      stockDisabled.value = false
    }

    watch(
      [() => formField.value.itemcode, () => formField.value.sph, () => formField.value.cyl, () => prdcode.value],
      ([itemcode, sph, cyl, prdCodeValue]) => {
        if (itemcode === null || sph === null || cyl === null) {
          lastStockKey.value = null
          stockStatus.value = false
          return
        }

        if (!prdCodeValue || lastStockKey.value === prdCodeValue) {

          return
        }
        lastStockKey.value = prdCodeValue

        // Yeni ürün seçiminde miktar senkron olarak 1'e sıfırlanır; stok cevabı
        // asenkron geldiği için orada resetlenirse, kullanıcı bu arada girdiği
        // miktarı kaybeder (race condition).
        formField.value.qty = 1

        const params = new URLSearchParams()
        params.append('method', 'getPrdStockByOffice')
        params.append('prdcode', prdCodeValue)
        const stockReqId = ++stockRequestId.value
        trackAddPending(
          axios
            .post('', params)
            .then(response => {
              // Ürün bu arada değiştiyse eski ürünün stok cevabı yenisini ezmesin
              if (stockReqId !== stockRequestId.value) return
              if (response.data.error) {
                stockStatus.value = false
                stockDisabled.value = true
                stockText.value = response.data.msg || 'Stok bilgisi alınamadı'
                stockType.value = 'error'

                return
              }
              stockDetail.value.merkez = 0
              stockDetail.value.depo = 0

              response.data.detail.forEach(item => {
                if (item.WarehouseCode === '3400' || item.WarehouseCode === 'PR_OPK_MKZ') {
                  stockDetail.value.merkez += Number(item.InventoryQty1) || 0
                } else {
                  stockDetail.value.depo += Number(item.InventoryQty1) || 0
                }
              })
              stockDetail.value.toplam = stockDetail.value.depo + stockDetail.value.merkez

              stockFn(stockDetail.value, formField.value.qty)
              stockStatus.value = true
            })
            .catch(e => {
              if (stockReqId !== stockRequestId.value) return
              stockStatus.value = false
              stockDisabled.value = true
              stockText.value = 'Bir hata oldu tekrar deneyin'
              stockType.value = 'error'
            }),
        )
      },
    )

    watch(
      [() => stockDetail.value, () => formField.value.qty],
      ([newStock, newQty]) => {
        stockFn(newStock, newQty)
      },
      { deep: true },
    )

    const stockFn = (stock, qty) => {
      stockDisabled.value = false

      if (formField.value.qty > 20) {
        stockText.value = 'Şubede ile temasa geçiniz'
        stockType.value = 'error'
        stockDisabled.value = true

        return
      }
      if (stock.depo >= qty) {
        // stockText.value = 'Depodaki Ürün Sayısı ' + stock.depo
        stockText.value = 'Şubede stok var'
        stockType.value = 'success'
      } else if (stock.depo == 0 && stock.toplam >= qty) {
        // stockText.value = 'Bu ürün merkezden gelecek'
        stockText.value = 'Şubede stok yok , merkezde Var'
        stockType.value = 'warning'
      } else if (stock.depo < qty && stock.toplam >= qty) {
        // stockText.value = `Bu üründen ${stock.depo} adet depodan ${qty - stock.depo} adeti merkezden gelecek`
        stockText.value = 'Şubede stok yok , merkezde var'
        stockType.value = 'warning'
      } else if (stock.toplam < qty) {
        stockDisabled.value = true

        // stockText.value = `Bu kadar ürün yok en fazla ${stock.toplam} adet sipariş edebilirsiniz.`
        stockText.value = 'Stok hiç bir yerde yok.'
        stockType.value = 'error'
      }
    }

    // "Karşı camı eklemek ister misiniz" dialogu drawer'ın dışında olduğundan, dialogdaki
    // tıklamalar drawer'ın "dışarı tıklama" kapanmasını tetikler; dialog açıkken yok sayılır.
    const onDrawerInput = val => {
      if (!val && dialog.value) return
      emit('update:is-add-edit-glass-sidebar', val)
    }

    const closeSidebar = () => {
      emit('update:is-add-edit-glass-sidebar', false)
      dialog.value = false
      isSubmitting.value = false
      addPendingCount.value = 0
      lastPriceKey.value = null
      lastStockKey.value = null
      priceLoading.value = false
      isAddPending.value = false
      setTimeout(() => {
        if (props.isAddEditGlassSidebar) return // panel bu arada yeniden açıldıysa kullanıcının girdiği veri silinmesin
        form.value.reset()

        formField.value = { ...formFieldCopy.value }
        formField.value.discount = []
        items.value = { ...itemsCopy.value }
      }, 500)
    }

    const submitForm = async () => {
      if (isSubmitting.value || isAddPending.value || priceLoading.value) return

      const resolvedPrdCode = buildGlassPrdCode(
        formField.value.itemcode,
        formField.value.sph,
        formField.value.cyl,
      )

      if (!resolvedPrdCode) {
        showAppSnackbar('Ürün kodu oluşturulamadı, SPH/CYL seçimini kontrol edin', 'warning')
        return
      }

      if (lastPriceKey.value !== resolvedPrdCode) {
        showAppSnackbar('Ürün fiyatı güncelleniyor, lütfen bekleyin', 'warning')
        return
      }

      isSubmitting.value = true
      const isValid = await form.value.validate()
      if (!isValid) {
        isSubmitting.value = false
        return
      }

      // qty=1, ilk fiyat sorgusunda zaten gönderilen değerdir; miktar hiç
      // değiştirilmediyse fiyatı tekrar sorgulamaya gerek yoktur.
      if (formField.value.qty !== 1) {
        const priceParams = new URLSearchParams()
        priceParams.append('method', 'getProductPrice')
        priceParams.append('prdcode', resolvedPrdCode)
        priceParams.append('qty', formField.value.qty)

        const priceResponse = await axios.post('', priceParams).catch(() => null)
        if (!priceResponse?.data || priceResponse.data.error) {
          showAppSnackbar(priceResponse?.data?.msg || 'Fiyat güncellenemedi, lütfen tekrar deneyin', 'warning')
          isSubmitting.value = false

          return
        }
        formField.value.price = priceResponse.data.detail.price
        formField.value.taxAmount = priceResponse.data.detail.taxAmount
        formField.value.netAmount = priceResponse.data.detail.netAmount
        formField.value.subTotal = priceResponse.data.detail.subTotal
        formField.value.discount = []
        if (priceResponse.data.detail.discAmount) {
          formField.value.discount.push(priceResponse.data.detail.discAmount)
        }
      }

      const itemSnapshot = {
        ...formField.value,
        prd_code: resolvedPrdCode,
        direction:
          formField.value.direction && typeof formField.value.direction === 'object'
            ? {
                ...formField.value.direction,
                reverse: formField.value.direction.reverse
                  ? { ...formField.value.direction.reverse }
                  : undefined,
              }
            : formField.value.direction,
        discount: [...formField.value.discount],
      }

      const params = new URLSearchParams()
      params.append('method', 'getCampaign')
      params.append('prd_code', resolvedPrdCode)
      params.append('qty', itemSnapshot.qty)

      trackAddPending(
        axios.post('', params).then(response => {
          if (response.data.error === false) {
            // Kampanya indirimi backend tarafından fiyata (discAmount/netAmount) zaten
            // yansıtılmış geliyor; cmpDiscValue, dip iskonto satırında ayrıca göstermek
            // için saklanır (Toplam İskonto'dan çıkarılır).
            itemSnapshot.cmpDiscValue = response.data.cmpDiscValue
            itemSnapshot.cmpDiscValueType = response.data.cmpDiscValueType
            itemSnapshot.cmpDiscMsg = response.data.msg
          }
        }),
      )
        .catch(() => {
          showAppSnackbar('Kampanya bilgisi alınamadı, ürün kampanyasız eklendi.', 'warning')
        })
        .finally(() => {
          itemSnapshot.id = newItemId()
          order.addItem(itemSnapshot)

          if (itemSnapshot.reverse) {
            dialog.value = true
          } else {
            closeSidebar()
          }
          isSubmitting.value = false
      })
    }

    const confrimText = computed(() => `${formField.value.direction?.reverse?.text} Camı Eklemek İstermisiniz`)

    const dialogConfrim = () => {
      const preserved = {
        brand: formField.value.brand,
        name: formField.value.name,
        itemcode: formField.value.itemcode,
        haswarrantycard: formField.value.haswarrantycard,
        fullname: formField.value.fullname,
        qty: formField.value.qty,
        reverseDirection: formField.value.direction?.reverse,
      }

      lastPriceKey.value = null
      lastStockKey.value = null
      priceRequestId.value += 1
      formField.value = { ...formFieldCopy.value }
      formField.value.discount = []
      form.value.reset()

      nextTick(() => {
        formField.value.brand = preserved.brand
        formField.value.name = preserved.name
        formField.value.itemcode = preserved.itemcode
        formField.value.haswarrantycard = preserved.haswarrantycard
        formField.value.fullname = preserved.fullname
        formField.value.qty = preserved.qty
        formField.value.reverse = false

        if (preserved.reverseDirection) {
          const reverseDirection = {
            ...preserved.reverseDirection,
            reverse: formField.value.direction,
          }
          items.value.direction = [reverseDirection]
          formField.value.direction = reverseDirection
        }

        formField.value.axe = null
      })

      dialog.value = false
    }

    return {
      alertGuard,
      order,
      form,
      formField,
      items,
      TESF,
      priceLoading,
      stockStatus,
      stockDetail,
      stockDisabled,
      stockText,
      stockType,
      STOCK_CONTROL,
      loadingSelectText,
      loadingSelectStatus,

      brandFocus,
      brandChange,

      nameFocus,
      nameChange,

      closeSidebar,
      onDrawerInput,
      dialog,
      submitForm,
      confrimText,
      dialogConfrim,
      isSubmitting,
      isAddPending,
      icons: {
        mdiClose,
        mdiSunglasses,
      },
    }
  },
}
</script>
